<template>
  <main class="settings">
    <app-loading v-if="isLoading"></app-loading>
    <div v-else>
      <section class="retry-area" v-if="responseError">
        <h3 class="retry-area__ttl">通信に失敗しました</h3>
        <a href="javascript:void(0);" @click="getRankingBooks" class="btn-retry btn-retry--short">リトライ</a>
      </section>
      <div v-else>
        <section class="label-link-area">
          <h2 class="label-link-area__ttl">登録情報</h2>
          <div class="label-link-area__main">
            <span class="label-link">
              <span class="label-link__head">アカウント名</span>
              <span class="label-link__status">{{userSettings.user.name_user}}</span>
            </span>
            <span class="label-link">
              <span class="label-link__head">メールアドレス</span>
              <span class="label-link__status">{{userSettings.user.email}}</span>
            </span>
            <span class="label-link">
              <span class="label-link__head">パスワード</span>
              <span class="label-link__status">●●●●●●●</span>
            </span>
          </div>
        </section>
        <section class="label-link-area">
          <h2 class="label-link-area__ttl">TOEICの目標設定</h2>
          <div class="label-link-area__main">
            <span class="label-link">
              <span class="label-link__head">目標スコア</span>
              <span class="label-link__status">{{userSettings.user.target_score}}</span>
            </span>
            <span class="label-link">
              <span class="label-link__head">現状スコア</span>
              <span class="label-link__status">{{userSettings.user.now_score}}</span>
            </span>
          </div>
          <div class="label-link-area__main pc-on">
            <a href="#" class="label-link label-link--center">
              <router-link :to="{ name: 'settingAccount'}" class="label-link__plan" v-if="userSettings">設定を変更する</router-link>
            </a>
          </div>
        </section>
        <section class="label-link-area">
          <h2 class="label-link-area__ttl">利用プラン</h2>
          <div class="label-link-area__main" v-if="needPremiumShow">
            <span class="label-link label-link--center">
              <span class="label-link__plan label-link__plan--pink">{{usingPlanName}}<span v-if="userSettings.using_plan.purchase_date && userSettings.using_plan.expires_date">（{{userSettings.using_plan.purchase_date | dateFormat}}~{{userSettings.using_plan.expires_date | dateFormat}}）</span></span>
            </span>
          </div>
          <div class="label-link-area__main" v-if="needUnlimitedShow">
            <span class="label-link label-link--center">
              <span class="label-link__plan label-link__plan--pink">{{unlimitedUsingPlanName}}<span v-if="userSettings.unlimited_using_plan.purchase_date && userSettings.unlimited_using_plan.expires_date">（{{userSettings.unlimited_using_plan.purchase_date | dateFormat}}~{{userSettings.unlimited_using_plan.expires_date | dateFormat}}）</span></span>
            </span>
          </div>
        </section>
        <section class="label-link-area">
          <h2 class="label-link-area__ttl">その他</h2>
          <div class="label-link-area__main">
            <a href="https://www.globeejapan.com/about.html" target="_blank" class="label-link">
              <span class="label-link__head label-link__head--bold">会社概要</span>
              <span class="label-link__status label-link__status--arrow">＞</span>
            </a>
            <a href="https://www.globeejapan.com/terms_of_service.html" target="_blank" class="label-link">
              <span class="label-link__head label-link__head--bold">利用規約</span>
              <span class="label-link__status label-link__status--arrow">＞</span>
            </a>
            <a href="https://www.globeejapan.com/privacy_policy.html" target="_blank" class="label-link">
              <span class="label-link__head label-link__head--bold">プライバシーポリシー</span>
              <span class="label-link__status label-link__status--arrow">＞</span>
            </a>
            <a href="https://www.globeejapan.com/contact.html" target="_blank" class="label-link">
              <span class="label-link__head label-link__head--bold">お問い合わせ</span>
              <span class="label-link__status label-link__status--arrow">＞</span>
            </a>
            <a href="https://www.globeejapan.com/tokusho.html" target="_blank" class="label-link">
              <span class="label-link__head label-link__head--bold">特定商取引法上の表示</span>
              <span class="label-link__status label-link__status--arrow">＞</span>
            </a>
            <a href="https://www.wantedly.com/companies/globeejapan/projects" target="_blank" class="label-link">
              <span class="label-link__head label-link__head--bold">採用情報</span>
              <span class="label-link__status label-link__status--arrow">＞</span>
            </a>
          </div>
        </section>
      </div>
    </div>
  </main>
</template>

<script>
  import Loading from '../common/Loading.vue';
  export default {
    title: '設定 | abceed（No.1 TOEIC教材アプリ）',
    headerTitle: '設定',
    description: 'abceed の設定はこちら',
    keywords: 'toeic,abceed,globee,設定',
    headerType: 'setting',
    components: {
      appLoading: Loading
    },
    data() {
      return {
        isFree: true,
        isUnlimitedFree: true,
        usingPlanName: "",
        unlimitedUsingPlanName: "",
        responseError: false,
        showChangePlan: false,
        showUnlimitedChangePlan: false
      }
    },
    created() {
      this.getUserSetting();
    },
    computed: {
      userSettings() {
        return this.$store.getters.userSettings;
      },
      isLoading() {
        return this.$store.getters.isLoading;
      },
      needUnlimitedShow() {
        return this.userSettings.unlimited_using_plan.product_id !== "free"
      },
      needPremiumShow() {
        if (this.userSettings.unlimited_using_plan.product_id !== "free" && this.userSettings.using_plan.product_id === "free") {
          return false;
        }
        return true;
      }
    },
    methods: {
      getUserSetting() {
        this.$store.dispatch("changeLoadingCondition", true);
        this.$store.dispatch('getUserSettings', {token:""})
          .then(data => {
            if (data === 'error') {
              this.responseError = true;
              this.$store.dispatch("changeLoadingCondition", false);
              return;
            }
            this.usingPlanName = data.subscriptions.find(obj => {
              return obj.product_id === data.using_plan.product_id;
            })["name_plan"];
            this.unlimitedUsingPlanName = data.unlimited_using_plan.name_plan;

            this.isFree = this.usingPlanName === 'FREE';
            this.isUnlimitedFree = this.unlimitedUsingPlanName === 'FREE';
            this.showChangePlan = data.show_change_plan;
            this.showUnlimitedChangePlan = data.unlimited_show_change_plan;
            this.$store.dispatch("changeLoadingCondition", false);
          }).catch(() => {
            this.responseError = true;
            this.$store.dispatch("changeLoadingCondition", false);
          });
      },
      click_plan_change() {
        if (this.isFree) {
          //Freeなら直接プレミアム画面に飛ばす
          this.$router.push({name: 'premiumHome'});
        } else {
          //プレミアム加入中ならプラン選択画面に飛ばす
          this.$router.push({name: 'settingPlanChange'});
        }
      },
      click_unlimited_plan_change() {
        if (this.isUnlimitedFree) {
          //Freeなら直接Unlimited画面に飛ばす
          this.$router.push({name: 'UnlimitedPlus'});
        } else {
          //Unlimited加入中ならUnlimitedプラン選択画面に飛ばす
          this.$router.push({name: 'UnlimitedPlanChange'});
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/settings/Home.vue